export interface Position {
  name: string
  displayName: string
  description?: string
  starred?: boolean
  state: {
    G?: any
    ctx?: any
    [key: string]: any
  }
}

export interface PositionSection {
  title: string
  positions: Position[]
  states?: Position[]
}

/** Legacy type aliases */
export type TestState = Position
export type TestStateSection = PositionSection

export function loadPositionSections(gameId: string, gameRegistry?: any): PositionSection[] {
  if (!gameRegistry) return []
  try {
    const resolved = gameRegistry.getResolvedModule?.(gameId)
    const rawSections = resolved?.positions || resolved?.testStates || []
    return rawSections.map((sec: any) => {
      const list = sec.positions || sec.states || []
      return {
        title: sec.title,
        positions: list,
        states: list,
      }
    })
  } catch (e) {
    console.warn(`Failed to load position sections for ${gameId}:`, e)
    return []
  }
}

export function loadPositions(gameId: string, gameRegistry?: any): Position[] {
  const sections = loadPositionSections(gameId, gameRegistry)
  return sections.flatMap((section) => section.positions)
}

/** Legacy helpers */
export const loadTestStateSections = loadPositionSections
export const loadTestStates = loadPositions
